import { FC, useContext, useEffect, useState } from 'react';
import { Button, Stack, Textarea } from '@chakra-ui/react';

import { UseOpenCloseReturn } from '~/core/hooks/useOpenClose';
import { useRunTangoRequest } from '~/core/shared/api/plugin';
import { Dialog } from '~/core/shared/components';
import { useEventHandler } from '~/core/shared/hooks/useEventHandler';
import {
  ApplicationContext,
  DocumentDetailsViewActionContext,
} from '../Layout.component';

export const TangoXmlPreviewModal: FC = () => {
  const { runTangoRequest } = useRunTangoRequest();
  const { actionContexts, applicationUuid } = useContext(ApplicationContext);
  const [xml, setXML] = useState<any>();

  const {
    action: { key },
  } = useContext(DocumentDetailsViewActionContext);

  const parameters: Record<string, string> = actionContexts[key]
    ? actionContexts[key].parameters
    : {};

  const tangoXmlPreviewModalApi: UseOpenCloseReturn = actionContexts[key].modal;

  const loadXML = useEventHandler(async (): Promise<void> => {
    try {
      const response = await runTangoRequest({
        params: { id: applicationUuid, ...parameters },
      });
      setXML(response?.preview);
    } catch {
      // Error is handled in useRunTangoRequest
    }
  });

  useEffect(() => {
    if (tangoXmlPreviewModalApi.open) {
      loadXML();
    }
  }, [tangoXmlPreviewModalApi.open]);

  return (
    <Dialog
      header="Tango XML"
      onOpenChange={tangoXmlPreviewModalApi.onOpenChange}
      open={tangoXmlPreviewModalApi.open}
      size="lg"
    >
      <Stack gap={4} p={6}>
        <Textarea minH="400" overflow="scroll" value={xml} whiteSpace="pre" />
        <Stack direction="row" justifyContent="end">
          <Button
            colorPalette="gray"
            fontSize="md"
            fontWeight="normal"
            onClick={tangoXmlPreviewModalApi.onClose}
            variant="outline"
          >
            Close
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};
